import './style.scss';
const s = plugin_frontend_script.smartcta_options;

Object.keys(s).forEach((key) => {
    if (key.endsWith('_color')) {
        document.documentElement.style.setProperty('--smartcta-' + key, s[key]);
    }
});
setTimeout(function () {
    initFloatingLabels();
}, 1000);

// console.log(s);

document.addEventListener(
    'DOMContentLoaded',
    function () {
        const smartcta = document.querySelector('.smartcta');
        const main_btn = document.querySelector('.smartcta--main__button-main');
        const main_inner = document.querySelector('.smartcta--cta-inner');
        const main_is_appended = false;
        const close_main_btn = document.querySelector('.smartcta--main__cta-close');
        const menu_btn = document.querySelector('.smartcta--menu-trigger');
        const close_all_btn = document.querySelector('.smartcta--close-all');
        const menu = document.querySelector('.smartcta--menu');

        smartcta.classList.add('js-loaded');

        smartcta.querySelectorAll('.hide-onload').forEach((item) => {
            item.style.display = 'block';
            item.classList.remove('hide-onload');
        });

        if (main_btn !== null && !main_btn.classList.contains('no-click') && !main_btn.classList.contains('direct-link')) {
            main_btn.addEventListener('click', function () {
                let main = document.querySelector('.smartcta--main__cta');

                if (main.classList.contains('opened')) {
                    closeAll();
                    logEvent('MainCTA', 'Close');
                } else {
                    smartcta.querySelectorAll('.opened').forEach((item) => {
                        item.classList.remove('opened');
                    });
                    main.classList.add('opened');
                    logEvent('MainCTA', 'Open');
                    somethingOpened();
                }
            });
        }

        if (main_btn !== null && main_btn.classList.contains('no-click')) {
            main_btn.addEventListener('click', function () {
                logEvent('MainCTA', 'Open');
            });
        }

        if (main_btn !== null && main_btn.classList.contains('direct-link')) {
            main_btn.addEventListener('click', function () {
                logEvent('MainCTA', 'DirectLink', main_btn.getAttribute('href'));
            });
        }

        close_main_btn.addEventListener('click', closeMainCta);
        if (menu_btn !== null) {
            menu_btn.addEventListener('click', toggleMenu);
        }
        if (close_all_btn !== null) {
            close_all_btn.addEventListener('click', closeAll);
        }

        document.querySelectorAll('.smartcta--menu-item').forEach((item, index) => {
            item.addEventListener('click', function () {
                if (item.classList.contains('has-contents')) {
                    fetchCtasById(index);
                }
                let spanText = item.querySelector('.smartcta--menu-item-content-in span').textContent;
                logEvent('SubCTA', 'Open', spanText);
            });
        });

        document.querySelectorAll('.smartcta--main__cta a:not(.smartcta--menu-item)').forEach((item, index) => {
            item.addEventListener('click', function () {
                let spanText = item.getAttribute('aria-label');
                logEvent('MainCTA', 'Linkclick', spanText);
            });
        });

        document.querySelectorAll('.smartcta--menu a:not(.smartcta--menu-item)').forEach((item, index) => {
            item.addEventListener('click', function () {
                let spanText = item.getAttribute('aria-label');
                logEvent('SubCTA', 'Linkclick', spanText);
            });
        });

        if (main_btn !== null && main_btn.classList.contains('auto-open')) {
            const flagKey = 'smartcta-auto-timeout';
            // Primary guard is sessionStorage (same-tab/session, instant availability)
            // Cookie remains as a cross-tab fallback.
            let hasFired = getSessionFlag(flagKey) || getCookie(flagKey) === 'true';

            if (!hasFired) {
                setTimeout(function () {
                    // Double-check at fire time to avoid races across fast navigations
                    if (!getSessionFlag(flagKey) && getCookie(flagKey) !== 'true') {
                        setSessionFlag(flagKey, true);
                        setCookie(flagKey, 'true');
                        fetchMain();
                    }
                }, 3000);
            }
        }

        function setCookie(name, value) {
            // Keep a short-lived cookie only as a fallback for cross-tab within a day
            const expires = new Date(Date.now() + 24 * 60 * 60 * 1000);
            const secure = location.protocol === 'https:' ? '; Secure' : '';
            document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}; SameSite=Lax${secure}`;
        }

        function getCookie(name) {
            const cookieValue = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
            return cookieValue ? cookieValue.pop() : '';
        }

        function setSessionFlag(name, value) {
            try {
                sessionStorage.setItem(name, value ? 'true' : 'false');
            } catch (e) {
                // Ignore if storage is unavailable
            }
        }

        function getSessionFlag(name) {
            try {
                return sessionStorage.getItem(name) === 'true';
            } catch (e) {
                return false;
            }
        }

        function fetchMain() {
            document.querySelector('.smartcta--main__cta').classList.add('opened');
            somethingOpened();
        }

        function fetchCtasById(id) {
            if (document.querySelector('[data-smartcta-id="' + id + '"]') === null) {
                let cta = doc.querySelector('[data-smartcta-id="' + id + '"]');
                document.querySelector('.smartcta--other-ctas').append(cta);
            }
            setTimeout(function () {
                toggleOtherCta(id);
            }, 1);

            document.querySelectorAll('.smartcta--other__cta-close').forEach((item) => {
                item.addEventListener('click', closeOtherCta);
            });
        }

        function toggleOtherCta(id) {
            let cta = document.querySelector('[data-smartcta-id="' + id + '"]');

            if (cta.classList.contains('opened')) {
                cta.classList.remove('opened');
                close_all_btn.classList.add('hidden');
                menu_btn.classList.remove('hidden');
                smartcta.classList.remove('contains-opened');
            } else {
                cta.classList.add('opened');
                toggleMenu();
                somethingOpened();
            }
        }

        function closeMainCta() {
            logEvent('MainCTA', 'Close');
            document.querySelector('.smartcta--main__cta').classList.remove('opened');
            close_all_btn.classList.add('hidden');
            menu_btn.classList.remove('hidden');
            smartcta.classList.remove('contains-opened');
        }

        function closeOtherCta() {
            document.querySelectorAll('.smartcta--other__cta').forEach((item) => {
                item.classList.remove('opened');
            });
            close_all_btn.classList.add('hidden');
            menu_btn.classList.remove('hidden');
            smartcta.classList.remove('contains-opened');
        }

        function somethingOpened() {
            smartcta.classList.add('contains-opened');
            close_all_btn.classList.remove('hidden');
            menu_btn.classList.add('hidden');
        }

        function closeAll() {
            smartcta.querySelectorAll('.opened').forEach((item) => {
                if (item.classList.contains('smartcta--menu')) {
                    logEvent('Menu', 'Close');
                } else if (item.classList.contains('smartcta--other__cta')) {
                }
                item.classList.remove('opened');
            });
            close_all_btn.classList.add('hidden');
            menu_btn.classList.remove('hidden');
            smartcta.classList.remove('contains-opened');
        }

        function toggleMenu() {
            if (menu !== null) {
                if (menu.classList.contains('opened')) {
                    menu.classList.remove('opened');
                    logEvent('Menu', 'Close');
                } else {
                    menu.classList.add('opened');
                    somethingOpened();
                    logEvent('Menu', 'Open');
                }
            }
        }
    },
    false,
);

function logEvent(type, action, details = '') {
    console.log('logEvent', type, action, details);
    if (window.dataLayer) {
        // GTM is active, fire the custom event
        window.dataLayer.push({
            event: 'smartcta',
            smartcta_type: type,
            smartcta_action: action,
            smartcta_details: details,
        });
    }
}

function initFloatingLabels() {
    var floatingLabels = document.querySelectorAll('.gfield');

    function floatLabel(e) {
        var inputField = e.target;
        var parent = inputField.parentElement.offsetParent;

        // get different parent element for Gravity Forms password fields to make the floating label work
        if (inputField.parentElement.parentElement.classList.contains('ginput_container_password')) {
            parent = inputField.parentElement;
        }

        parent.classList.add('smartcta--floating-label');
    }

    for (var i = 0, fLen = floatingLabels.length; i < fLen; i++) {
        var element = floatingLabels[i].querySelector('input, textarea');

        if (element) {
            element.addEventListener('focus', function (e) {
                floatLabel(e);
            });

            element.addEventListener('blur', function (e) {
                var inputValue = e.target.value;
                var parent = e.target.parentElement.offsetParent;
                if (inputValue === '' || inputValue === undefined) {
                    parent.classList.remove('smartcta--floating-label');
                } else {
                    parent.classList.add('smartcta--floating-label');
                }
            });
        }
    }

    var inputs = document.querySelectorAll('.ginput_container > input, .ginput_container > textarea, .ginput_container_password input');

    for (var j = 0, len = inputs.length; j < len; j++) {
        var inputValue = inputs[j].value;
        var inputParent = inputs[j].parentElement.parentElement;
        if (inputValue) {
            inputParent.classList.add('smartcta--floating-label');
        }
    }
}

if (document.getElementsByClassName('gform_body').length) {
    var firstTimeLoad = true;
    $(document).bind('gform_post_render', function () {
        initFloatingLabels();
        if (firstTimeLoad) {
            firstTimeLoad = false;
        } else {
            return;
        }
    });
}

jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
    let form = $('#gf_' + formId).parents('.form');
    if (form.length && form.parents('.smartcta'.length)) {
        form.prevAll().hide();
        let formTitle = document.querySelector('#gf_' + formId).parentElement.parentElement.querySelector('.gform_title').textContent;
        if (formTitle === '') {
            formTitle = 'Form has no specified name';
        }
        logEvent('Form', 'Submit', formTitle);
    }
});

function initializeCarousel(carousel) {
    var indicator = carousel.querySelector('#indicator');
    var elements = carousel.querySelectorAll('.carousel-inner > *');
    var currentIndex = 0;

    function renderIndicator() {
        // this is just an example indicator; you can probably do better
        indicator.innerHTML = '';
        for (var i = 0; i < elements.length; i++) {
            var button = document.createElement('button');
            button.innerHTML = '\u2022';
            button.classList.add(i === currentIndex ? 'active' : 'inactive');
            (function (i) {
                button.onclick = function () {
                    elements[i].scrollIntoView();
                };
            })(i);
            indicator.appendChild(button);
        }
    }

    var observer = new IntersectionObserver(
        function (entries, observer) {
            // find the entry with the largest intersection ratio
            var activated = entries.reduce(function (max, entry) {
                return entry.intersectionRatio > max.intersectionRatio ? entry : max;
            });
            if (activated.intersectionRatio > 0) {
                currentIndex = elementIndices[activated.target.getAttribute('id')];
                renderIndicator();
            }
        },
        {
            root: carousel,
            threshold: 0.5,
        },
    );
    var elementIndices = {};
    for (var i = 0; i < elements.length; i++) {
        elementIndices[elements[i].getAttribute('id')] = i;
        observer.observe(elements[i]);
    }
}

// Usage example:
var carousels = document.querySelectorAll('.carousel');
carousels.forEach(function (carousel) {
    initializeCarousel(carousel);
});
